export enum PackagingTypeEnum {
    CUSTOMER_PACKAGING = 'CUST',
    ENVELOPE = 'ENVELOPE',
    PAK = 'PAK',
    BOX = 'BOX',
    FEDEX_10KG_BOX = 'FEDEX_10KG_BOX',
    FEDEX_25KG_BOX = 'FEDEX_25KG_BOX',
    PALLET = 'PALLET',
    STACKABLE_PALLET = 'STACKABLE_PALLET'
}
